const initialState = {
  user: undefined,
  editUser: undefined,
  token: undefined,
  users: [],
  newUserSuccess: false,
  qr: undefined
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'getUsers/success':
      return { ...state, users: action.payload }

    case 'getUser/success':
      return { ...state, editUser: action.payload }

    case 'newUser/success':
      return { ...state, newUserSuccess: true }

    case 'getQr/success':
      return { ...state, qr: action.payload }

    case 'getMe/success':
      return { ...state, me: action.payload }

    case 'updateTwoFactorStatus/success':
      return { ...state, me: action.payload }

    case 'loadUserData':
      return action.payload

    case 'user/login':
      return {
        ...state,
        user: action.payload.id,
        role: action.payload.role,
        username: action.payload.username,
        token: action.payload.token,
        email: action.payload.email,
        sections: action.payload.sections,
        riskAccessType: action.payload.riskAccessType,
        isDemo: action.payload.isDemo
      }

    case 'associate/success':
      return {
        ...state,
        user: action.payload.id,
        role: action.payload.role,
        username: action.payload.username,
        token: action.payload.token,
        email: action.payload.email,
        sections: action.payload.sections,
        riskAccessType: action.payload.riskAccessType,
        isDemo: action.payload.isDemo
      }

    case 'logout':
      return initialState

    default:
      if (action.type.endsWith('/error') && action.status === 401) {
        return initialState
      }
      return state
  }
}
